import React, {
  Fragment,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import {
  BackgroundDiv,
  BottomBtnArea,
  ContentBody,
  NoticeText,
  SelectedDiv,
} from "./ReceiptStyle";
import { HeaderTitle } from "./../../common/Header/HeaderStyle";
import { IC, ListIcon } from "../../../resources/Assets";
import styled, { css } from "styled-components";
import List from "./../../../components/UI/List/List";
import { Button, Layer } from "../../../components";
import { _O } from "../../../modules/utils";
import {
  PostApi1975,
  PostApiCmsnInfo,
} from "../../../modules/network/padoPost";
import { AppContext } from "../../../components/AppProvider";
import CouponList from "../../common/Coupon/CouponList";

const ReceiptStepTwo = props => {
  const {
    cardInfo,
    submit,
    seqNo,
    setPageIdx,
    setIssueCpnNo,
    couponLayerView,
    setCouponLayerView,
    setCouponInfo,
  } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [btnActive, setBtnActive] = useState(true);

  const [layerView, setLayerView] = useState(true);
  const [completeLayerView, setCompleteLayerView] = useState(false);

  const [couponListView, setCouponListView] = useState(false);

  const returnStatus = () => {
    // if (cardInfo) {
    return "default";
    // } else {
    // return "active";
    // }
  };

  const returnRIcon = target => {
    if (returnStatus(target) === "active") {
      return ListIcon.RECEIPT.R_ICON.CHEVRON_ACTIVE;
    } else if (returnStatus(target) === "default") {
      return ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT;
    } else {
      return "";
    }
  };

  const clickEvent = () => {
    if (seqNo) {
      setPageIdx(1);
    } else {
      if (btnActive) {
        setBtnActive(false);
        submit(setBtnActive, setCompleteLayerView);
      }
    }
  };
  const [couponList, setCouponList] = useState([]);
  const [useCoupon, setUseCoupon] = useState();
  const [cmsnInfo, setCmsnInfo] = useState();

  const getMyCoupon = () => {
    PostApi1975(userinfo, cfg, "TM", "ALL")
      .then(result => {
        if (result.rsltCd === "E000") {
          setCouponList(result.rslt);
          setUseCoupon(result.rslt[0]);
          // setIssueCpnNo(result.rslt[0].issueCpnNo);
        }
      })
      .catch(err => {
        console.log("err:: ", err);
      });
  };

  const getCmsnInfo = () => {
    PostApiCmsnInfo(userinfo, cfg, "TM")
      .then(result => {
        if (result.rsltCd === "E000") {
          setCmsnInfo(result.rslt);
        }
      })
      .catch(err => {
        console.log("err:: ", err);
      });
  };

  const discountPrice = () => {
    let returnValue = "";
    if (useCoupon.adptUnit === "PER") {
      returnValue = (cmsnInfo.cmsnAmt * useCoupon.adptAmt) / 100;
    } else {
      returnValue = useCoupon.adptAmt;
    }

    return parseInt(returnValue).toLocaleString("ko-KR", 0) + "원";
  };

  useEffect(() => {
    if (useCoupon) {
      setIssueCpnNo(useCoupon.issueCpnNo);
      setCouponInfo(useCoupon);
    }
  }, [useCoupon]);

  useLayoutEffect(() => {
    getCmsnInfo();
    getMyCoupon();
  }, []);

  return (
    <Fragment>
      {couponListView ? (
        <CouponList
          useCoupon={useCoupon}
          setUseCoupon={setUseCoupon}
          setCouponListView={setCouponListView}
        />
      ) : (
        <Fragment>
          <BackgroundDiv
            style={{
              flexFlow: "column",
              height: "100vh",
            }}>
              <HeaderTitle style={{paddingTop: '8px'}}>
              <div
                style={{ width: "40px", height: "40px" }}
                onClick={() => props.setPageIdx(1)}>
                <img src={IC.etc.ICON_CHEVRON_LEFT} />
              </div>
              {/* <div>약국정보</div> */}
              <div>{props.hederTitle}</div>
              <div style={{ width: "40px", height: "40px" }}>
                {/* <img src={ArrowLeft} /> */}
              </div>
            </HeaderTitle>

            <ContentBody
              style={{ padding: "40px 0px", paddingBottom: "146px" }}>
              <InfoBody style={{ padding: "0px 20px" }}>
                <NoticeText>
                  결제 카드와
                  <br />
                  쿠폰정보를 확인해주세요
                </NoticeText>

                <CardInfoBody>
                  <SelectedDiv
                    active={true}
                    onClick={() => props.setPageIdx(5)}>
                    <List
                      data={{
                        CONTAINER_SHORT: true,
                        STATUS: returnStatus("card"),
                        L_ICON: <img src={ListIcon.RECEIPT.L_ICON.CARD} />,
                        TITLE: "결제카드",
                        SUB_TEXT: {
                          status: !cardInfo ? "active" : "default",
                          text: !cardInfo
                            ? ""
                            : cardInfo.cardNm + "-" + cardInfo.cardNo,
                        },
                        R_ICON: returnRIcon("card"),
                        ACTION: "",
                      }}
                    />
                  </SelectedDiv>

                  <CardDesc>
                    <div style={{ display: "flex", gap: "4px" }}>
                      <DescText>•</DescText>
                      <DescText>
                        병원 진료비는 진료 항목에 따라 달라질 수 있으며, 병원
                        방문을 안내받더라도 진료비가 청구됩니다.
                      </DescText>
                    </div>

                    <div style={{ display: "flex", gap: "4px" }}>
                      <DescText>•</DescText>
                      <DescText>
                        비대면 진료시 본인부담금이 추가로 청구됩니다.{" "}
                      </DescText>
                    </div>

                    <div style={{ display: "flex", gap: "4px" }}>
                      <DescText>•</DescText>
                      <DescText>
                        진료 완료 후, 케어포미 비대면진료 서비스 이용료가 별도로
                        발생합니다.
                      </DescText>
                    </div>
                  </CardDesc>
                </CardInfoBody>
              </InfoBody>
              <SeparateLine />
              {/* 쿠폰영역 */}
              <CouponBody style={{ padding: "0px 20px" }}>
                <div
                  style={{ display: "flex", flexFlow: "column", gap: "4px" }}>
                  <TextContainer>
                    <Text>예상 진료비</Text>
                    <Text bold={true}> 진료 후 의사가 결정</Text>
                  </TextContainer>
                  {cmsnInfo && (
                    <TextContainer>
                      {/* <Text>{cmsnInfo.prodNm}</Text> */}
                      <Text>비대면진료 서비스 이용료</Text>
                      <Text bold={true}>
                        {parseInt(cmsnInfo.cmsnAmt).toLocaleString("ko-KR", 0) +
                          "원"}
                      </Text>
                    </TextContainer>
                  )}
                  {useCoupon && cmsnInfo && (
                    <TextContainer>
                      <Text
                        style={{
                          color: "#6b65de",
                          display: "flex",
                          gap: "4px",
                          paddingLeft: "8px",
                        }}>
                        <div>•</div>
                        <div>할인쿠폰 사용</div>
                      </Text>
                      <Text bold={true} style={{ color: "#6b65de" }}>
                        {"- " + discountPrice()}
                      </Text>
                    </TextContainer>
                  )}
                </div>

                <SelectedDiv
                  active={true}
                  onClick={() => {
                    setCouponListView(true);
                  }}
                  style={{ display: "grid" }}>
                  <List
                    data={{
                      CONTAINER_SHORT: true,
                      STATUS: returnStatus("card"),
                      L_ICON: <img src={ListIcon.RECEIPT.L_ICON.COUPON} />,
                      // TITLE: couponList.length > 0 ? useCoupon.cpnNm : "",
                      TITLE: useCoupon
                        ? useCoupon.cpnNm
                        : couponList.length > 0
                        ? "선택된 쿠폰이 없습니다."
                        : "사용가능한 쿠폰이 없습니다.",
                      // SUB_TEXT: {
                      //   status: "default",
                      //   text:
                      //     couponList.length > 0
                      //       ? ""
                      //       : "사용가능한 쿠폰이 없습니다.",
                      // },
                      R_ICON: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
                      ACTION: "",
                    }}
                  />
                </SelectedDiv>
              </CouponBody>
            </ContentBody>

            {cardInfo && (
              <BottomBtnArea
                style={{ display: "flex", flexFlow: "column", gap: "8px" }}>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "14px",
                    color: "#666",
                  }}>
                  예약진행시 개인정보 수집 및 제공에 동의한것으로 간주합니다.
                </span>
                <Button
                  severity="primary"
                  disable="off"
                  clickEvent={() => clickEvent()}>
                  {/* {seqNo ? "수정" : "비대면진료 예약"} */}
                  예약하기
                </Button>
              </BottomBtnArea>
            )}
          </BackgroundDiv>
          {couponLayerView && couponList.length > 0 && (
            <Layer
              title="사용가능한 쿠폰이 있어 진료비 결제시 자동으로 사용됩니다"
              desc={[
                "쿠폰을 적용하면 비대면진료 서비스 이용료 할인 혜택을 받으실 수 있습니다.",
              ]}
              ps=""
              button={[
                {
                  severity: "primary",
                  disable: "off",
                  small: false,
                  clickEvent: () => setCouponLayerView(false),
                  text: "확인",
                },
              ]}
            />
          )}

          {completeLayerView && (
            <Layer
              headerIcon={IC.check.ICON_PURPLE_CHECK}
              title="예약신청이 완료되었습니다"
              desc={[
                "병원 담당자가 내용을 확인하면",
                <br />,
                "예약확정 알림톡이 전송됩니다",
              ]}
              ps=""
              button={[
                {
                  severity: "primary",
                  disable: "off",
                  small: false,
                  clickEvent: () => _O.Open("/"),
                  text: "확인",
                },
              ]}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

const CardInfoBody = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 16px;
  padding: 0;
`;

const CardDesc = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
`;

const DescText = styled.span`
  align-self: stretch;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #666;
`;

const CouponBody = styled.div`
  align-self: stretch;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 16px;
  /* padding: 20px; */
  background-color: #fff;
`;

const TextContainer = styled.div`
  height: 22px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0;
`;

const Text = styled.span`
  height: 22px;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  ${props =>
    props.bold
      ? css`
          font-weight: 500;
          color: #333;
        `
      : css`
          font-weight: normal;
          color: #888;
        `}
`;

const SeparateLine = styled.div`
  height: 8px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  gap: 4px;
  background-color: #fafafa;
`;

const InfoBody = styled.div`
  /* display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  margin-top: 40px; */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
  align-self: stretch;
`;

export default ReceiptStepTwo;
